import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';

Swiper.use([EffectFade, Navigation, Pagination, Thumbs, Autoplay]);

const defaultOptions = {
  speed: 400,
};

const initSlider = (element, options) => {
  return new Swiper(element, {
    ...defaultOptions,
    ...options,
  });
};

export default initSlider;
